import React from 'react';
import './slideErrorStyle.scss';

export const SlideErrorFallback = () => (
  <div className="slide-errors">
    <h3>Sorry this page isn't available right now.</h3>
    <p>Please try again later and contact us if the issue persists.</p>
  </div>
);
